<template>
    <Modal
        v-model="showColumnDescModal"
        title="编辑字段描述"
        :mask-closable="false"
        width="800" 
    >
        <div class="table-container" style="max-height: 350px; overflow-y: auto; margin-bottom: 20px;">
            <stand-pagination-table
                :columns="mainTable.columns"
                :data="mainTable.data"
                :loading="mainTable.loading"
                :table-search="mainTable.tableSearch"
                :table-load-event="getColumnDesc"
                :totalSummaryFieldDatas="mainTable.sumData"
                :autoHeight = "true"
                :showPage="true"
            />
        </div>

        <Divider>编辑区域</Divider>

        <Form ref="columnForm" :model="columnDescForm" :rules="formRules" :label-width="80">
            <FormItem label="字段名" prop="ColumnName">
                <Input
                    v-model="columnDescForm.ColumnName"
                    placeholder="请输入字段名"
                />
            </FormItem>
            <FormItem label="字段描述" prop="DescName">
                <Input
                    v-model="columnDescForm.DescName"
                    placeholder="请输入字段描述"
                />
            </FormItem>
        </Form>
        <div slot="footer">
            <Button @click="handleCancel">取消</Button>
            <Button type="primary" :loading="isSaving" @click="handleSave">
                保存
            </Button>
        </div>
    </Modal>
</template>

<script>
import search from "@/libs/search";
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/pagination-table/pagination-table.vue';
import { getColumnDescList, saveColumnDesc } from '@/api/modules/system-management/log-management';

export default {
    name: "ColumnDescModal",
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            showColumnDescModal: false,
            isSaving: false,
            
            // 字段描述表单数据模型
            columnDescForm: {
                Id: "",
                ColumnName: "",
                DescName: ""
            },
            
            formRules: {
                ColumnName: [
                    { required: true, message: '字段名不能为空', trigger: 'blur' }
                ],
                DescName: [
                    { required: true, message: '字段描述不能为空', trigger: 'blur' }
                ]
            },
            
            // 主表格数据和配置
            mainTable: {
                columns: [
                    { title: "字段名", key: "ColumnName", width: 300, align: 'center' },
                    { title: "字段描述", key: "DescName", align: 'center' }
                    /* {
                        title: "操作",
                        key: "action",
                        width: 150,
                        align: 'center',
                        render: (h, params) => {
                            return h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.handleEdit(params.row);
                                    }
                                }
                            }, '编辑');
                        }
                    } */
                ],
                data: [],
                sumData: [],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    methods: {
        /**
         * @description 打开模态框，并加载表格初始数据
         */
        openColumnDescModal() {
            this.showColumnDescModal = true;
            // 清空上次的编辑表单
            this.resetForm();
            // 加载表格数据
            this.getColumnDesc();
        },
        
        /**
         * @description 获取字段列表数据
         */
        async getColumnDesc() {
            this.mainTable.loading = true;
            try {
                const res = await getColumnDescList(this.mainTable.tableSearch);
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    this.mainTable.sumData = res.data.sumRecord;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
                else {
                    this.$Message.error(res.msg || '获取数据失败');
                }
            }
            catch (error) {
                console.error("获取字段列表失败:", error);
                this.$Message.error('网络请求失败，请稍后重试');
            }
            finally {
                this.mainTable.loading = false;
            }
        },

        /**
         * @description 处理编辑操作，填充表单数据
         */
        handleEdit(row) {
            this.columnDescForm = { ...row };
        },

        /**
         * @description 处理保存操作
         */
        async handleSave() {

            const isValid = await this.$refs.columnForm.validate();
            if (!isValid) return;

            this.isSaving = true;
            try {
                const res = await saveColumnDesc(this.columnDescForm);
                if (res.code === 0) {
                    this.$Message.success("保存成功");
                    this.resetForm();      // 清空表单
                    await this.getColumnDesc(); // 重新加载数据
                }
                else {
                    this.$Message.error(res.msg || '保存失败');
                }
            }
            catch (error) {
                console.error("保存字段描述失败:", error);
                this.$Message.error('网络请求失败，请稍后重试');
            }
            finally {
                this.isSaving = false;
            }
        },
        
        /**
         * @description 关闭并重置模态框
         */
        handleCancel() {
            this.showColumnDescModal = false;
            this.resetForm();
        },

        /**
         * @description 重置表单为空状态
         */
        resetForm() {
            this.columnDescForm = { Id: "", ColumnName: "", DescName: "" };
        }
    }
};
</script>